
import React, { useEffect, useState, useMemo } from 'react';
import { getdata, TIMEDATA, DAILYAVAILABLETIME, CLOSEDDATA, updatedata,formatdate, getdate, deletedata } from "../../util/global";
import DashboardTableBill from './DashboardTableBill';
import DashboardTableItem from "./DashboardTableItem";
import ZohoConfigForm from "./ZohoConfigForm"

const ZohoSetting = () => {
  const [zohoconfig, setzohoconfig] = useState({});
  const [showmodal, setshowmodal] = useState(false);

  const fetchdata = async () => {
    try {
      let z = await getdata({"datatype":"zohoconfigdata"}, "/zohoconfig");
      if (z.data && z.data.length > 0)   
        setzohoconfig(z.data[0]);
      console.log(zohoconfig);
    } catch (err) { console.error(err); }
  };


  const openzohoconfigform = () => {
    setshowmodal("showzohoconfigform");
  };
  const updatezohoconfig = async () => {

    try {
      zohoconfig.config = JSON.parse(JSON.stringify(zohoconfig.config));
    } catch (ex) {
      console.log(ex);
      alert("invalid json");
      return false;
    }
    zohoconfig.datatype = "zohoconfigdata";
    let payload = {data:zohoconfig};

    console.log(payload);    
    const result = await updatedata(payload);
    fetchdata();
    setshowmodal(false);
  };



  useEffect(() => { fetchdata(); }, []);
  

  return (
    <div className="content-area">

      <a href={"#"} onClick={(e) => {openzohoconfigform();}}>Zoho Config</a>
      <ZohoConfigForm 
        showmodal={showmodal} 
        setshowmodal={setshowmodal} 
        zohoconfig={zohoconfig} 
        updatezohoconfig={updatezohoconfig}  
        setzohoconfig={setzohoconfig}    
      />
    </div>
  );
};

export default ZohoSetting;